{
  "name": "eh-clientadvisorportal-web",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:qa": "ng serve --configuration=qa",
    "start:dev": "ng serve --configuration=dev",
    "start:staging": "ng serve --configuration=staging",
    "start:prod": "ng serve --configuration=production",
    "start:uat": "ng serve --configuration=uat",
    "build": "ng build",
    "build:qa": "ng build --configuration=qa",
    "build:dev": "ng build --configuration=dev",
    "build:staging": "ng build --configuration=staging",
    "build:prod": "ng build --configuration=production",
    "build:uat": "ng build --configuration=uat",
    "test": "ng test --watch=false",
    "test:file": "ng test --watch=false --include='**/app.component.spec.ts'",
    "test:coverage": "ng test --configuration coverage --no-watch",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.12",
    "@angular/cdk": "^21.2.10",
    "@angular/common": "^21.2.12",
    "@angular/compiler": "^21.2.12",
    "@angular/core": "^21.2.12",
    "@angular/flex-layout": "^15.0.0-beta.42",
    "@angular/forms": "^21.2.12",
    "@angular/google-maps": "^20.2.14",
    "@angular/material": "^21.2.10",
    "@angular/material-moment-adapter": "^21.2.10",
    "@angular/platform-browser": "^21.2.12",
    "@angular/platform-browser-dynamic": "^21.2.12",
    "@angular/router": "^21.2.12",
    "@googlemaps/js-api-loader": "^2.0.2",
    "@microsoft/applicationinsights-web": "^3.4.1",
    "@types/google.maps": "^3.58.1",
    "jwt-decode": "^4.0.0",
    "moment": "^2.29.1",
    "ngx-mat-select-search": "^8.0.5",
    "rxjs": "^7.5.6",
    "tslib": "^2.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.6",
    "@angular-eslint/schematics": "^21.0.1",
    "@angular/cli": "^21.2.6",
    "@angular/compiler-cli": "^21.2.7",
    "@types/google.maps": "^3.58.1",
    "@types/node": "^20.19.37",
    "@vitest/coverage-v8": "^4.1.3",
    "jsdom": "^29.0.2",
    "prettier": "^3.6.2",
    "sonar-scanner": "^3.1.0",
    "ts-node": "~10.9.1",
    "typescript": "5.9.3",
    "vitest": "^4.1.3"
  }
}
